/*
 * @providesModule SKZConstantsImplementation
 *
 */

export const SKZ_LIVE_EVENT_DONT_SHOW_PRIZE_DETAILS = 'SKZLiveEventPrizeDetailsDontShowAgain';
export const SKZ_TOURNAMENT_JOIN_VIA_AD_WATCH = 'SKZDidWatchAdForTournamentJoin';
export const PENDING_PLOW_TUTORIAL_KEY = 'seenPendingTutorialSKZ';
export const SKZ_DEFAULTS_HAS_REQUESTED_PUSH = 'hasRequestedPushSKZ';
export const SKZ_LAST_PUSH_PROMPT_TIME_MS = 'lastPushPromptTimeMs';
export const PLOW_FTUE_MODALS_ENABLED_KEY = 'plowFTUEModalsEnabledSKZ';
export const SKZ_REPLAY_BETA_ENABLED = 'replayBetaEnabled';
export const SKZ_UNREAD_SUPPORT_MESSAGES_COUNT = 'unreadSupportMessagesCountSKZ';

// Mopub Constants
export const SKZ_MOPUB_INTERSTITIAL = 'interstitial';
export const SKZ_MOPUB_VC_INTERSTITIAL = 'vc_interstitial';
export const SKZ_MOPUB_3RD_PARTY_INTERSTITIAL = 'third_party_interstitial';
export const SKZ_MOPUB_3RD_PARTY_REWARDED = 'third_party_rewarded';
export const SKZ_MOPUB_IPHONE_PORTRAIT = 'iPhone_portrait';
export const SKZ_MOPUB_IPHONE_LANDSCAPE = 'iPhone_landscape';
export const SKZ_MOPUB_IPAD_PORTRAIT = 'iPad_portrait';
export const SKZ_MOPUB_IPAD_LANDSCAPE = 'iPad_landscape';
export const SKZ_MOPUB_ANDROID_PHONE_LANDSCAPE = 'AndroidPhone_landscape';
export const SKZ_MOPUB_ANDROID_PHONE_PORTRAIT = 'AndroidPhone_portrait';
export const SKZ_MOPUB_ANDROID_TABLET_LANDSCAPE = 'AndroidTablet_landscape';
export const SKZ_MOPUB_ANDROID_TABLET_PORTRAIT = 'AndroidTablet_portrait';

// Rating Prompt Defined Constants
export const SKZ_RATING_PROMPT_RATED_VERSION = 'iRateRatedVersionChecked';
export const SKZ_RATING_PROMPT_DECLINED_VERSION = 'iRateDeclinedVersion';
export const SKZ_RATING_PROMPT_LAST_REMINDED = 'iRateLastReminded';
export const SKZ_RATING_PROMPT_LAST_VERSION_USED = 'iRateLastVersionUsed';
export const SKZ_RATING_PROMPT_FIRST_USED = 'iRateFirstUsed';
export const SKZ_RATING_PROMPT_USE_COUNT = 'iRateUseCount';
export const SKZ_RATING_PROMPT_EVENT_COUNT = 'iRateEventCount';
export const SKZ_RATING_PROMPT_SAMSUNG_STORE_FORMAT = 'samsungapps://ProductDetail/';
export const SKZ_RATING_PROMPT_IOS_STORE_FORMAT = 'itms-apps://itunes.apple.com/app/id';
export const SKZ_RATING_PROMPT_IOS_STORE_RATE_FORMAT =
  'itms-apps://itunes.apple.com/xx/app/skillz/id%s?action=write-review'; // for use with sprintf

// Orientation Keys
export const SKZ_DEFAULTS_ORIENTATION_ANDROID = 'orientation';
export const SKZ_DEFAULTS_ORIENTATION = 'orientationSKZ';
export const SKZ_PORTRAIT = 'PORTRAIT';
export const SKZ_LANDSCAPE = 'LANDSCAPE';

// Chat keys
export const SKZ_USER_CHAT_LAUNCH_COUNT = 'user.chat.launch.count';
export const SKZ_CONTACTS_PERMISSION_GRANTED = 'SKZContactsPermissionGranted';
export const SKZ_CONTACTS_DENIED_PERMISSION = 'SKZContactsDeniedPermission';
export const SKZ_CONTACTS_NEED_PERMISSION = 'SKZContactsNeedPermission';
export const SKZ_CONTACTS_RESTRICTED_PERMISSION = 'SKZContactsRestrictedPermission';
export const SKZ_HAS_LAUNCHED_CHAT = 'SkillzHasLaunchedChat';
export const SKZ_CONTACTS_HAS_GIVEN_PERMISSION = 'chat.contacts.permissions';
export const SKZ_USERS_WITH_CONTACTS_UPLOADED = 'SKZContactsUploaded';
export const SKZ_CHAT_LAST_JOINED_ROOM = 'chat.rooms.last_joined_room';
export const SKZ_CHAT_FALL_BACK_ROOM = 'chat.rooms.fall_back_room';
export const SKZ_UNREAD_CHAT_MESSAGES_COUNT = 'unreadChatMessagesCountSKZ';
export const SKZ_CHAT_LAST_NOTIFICATION_PROMPT = 'user.chat.last_push_notification_prompt';
export const SKZ_CHAT_BUTTON = 'Chat Button';

// Chat FTUE Keys
export const SKZ_INTRO_CHAT_FTUE_SEEN = 'user.chat.ftue.intro_seen';
export const SKZ_SWIPE_FTUE_SEEN = 'user.chat.ftue.swipe_seen';
export const SKZ_MENTIONS_FTUE_SEEN = 'user.chat.ftue.mentions_seen';
export const SKZ_PENDING_FTUE_SEEN = 'user.chat.ftue.pending_seen';
export const SKZ_GROUP_FTUE_SEEN = 'user.chat.ftue.group_seen';
export const SKZ_CHAT_IS_FIRST_TIMER = 'user.chat.is.first.timer';
export const SKZ_LAST_SEEN_MESSAGES_BY_ROOM = 'lastSeenMessagesByRoomSKZ';

export const SKZ_IS_COMING_FROM_SKIP_FTUE_DEEP_LINK = 'skipFTUEDeepLink';
export const SKZ_SKIP_FTUE = 'skip_ftue';
export const SKZ_SKIP_FTUE_TRUE = 'YES';
export const SKZ_SKIP_FTUE_FALSE = 'NO';

export const SKZ_STAFF_REFUND_FTUE_SEEN = 'plow.staff_refund.ftue.seen';

export const SKZ_HAS_SEEN_LEADERBOARDS_UNLOCKED = 'hasSeenLeaderboardsUnlockedSKZ';

export const SKZ_LAST_LEAGUES_KEY = 'lastLeaguesSKZ';
export const SKZ_LAST_SEEN_CONCLUDED_LEAGUES_KEY = 'lastSeenConcludedLeaguesSKZ';
export const SKZ_LEAGUES_STATUS_INTERSTITIAL_SKIPS = 'leaguesStatusInterstitialSkipsSKZ';

export const STAFF_BADGES_ENABLED = 'staff_badge_enabled';

export const FRIENDS_TOURNAMENTS_SEEN_TOURNAMENTS = 'friends_tournaments_seen_tournaments';

export const LOCATION_AUTHORIZATION_ENABLED = 'skillz_app_location_enabled';
export const LOCATION_SOFT_PROMPT_SEEN = 'didPromptLocationMgr';

export const SKZ_DO_NOT_ASK_AGAIN_SMS = 'SKZ_DO_NOT_ASK_AGAIN_SMS';

export const HAS_DENIED_CONTACTS_HARD_PROMPT = 'hasDeniedContactsPrompt';

export const REWARD_CALENDAR_NEXT_REWARD = 'rewardCalendarNextRewardTimeSKZ';

// FTUE-like keys
export const SKZ_HAS_SEEN_HOW_TO_LEVEL_UP_MODAL = 'hasSeenHowToLevelUpModal';
export const SKZ_HAS_SEEN_TROPHY_INFO_MODAL = 'shownTrophyTutorialSKZ';
export const SKZ_HAS_SEEN_STORE_TUTORIAL_KEY = 'hasSeenStoreTutorialSKZ';
export const SKZ_SHOULD_SKIP_PLAY_AGAIN_INFO = 'shouldSkipPlayAgainInfoSKZ';
export const SKZ_GAME_OPERATIONS_TUTORIAL_STEP_INDEX = 'GameOperationsTutorialStepIndex';

// LTO Badge keys
export const SKZ_ACTIVE_LTO = 'active_lto';
export const SKZ_LTO_SHOW_BADGE = 'lto_show_badge';
export const SKZ_LTO_BADGE_SHOWN_IDS = 'skz_lto_badge_shown_ids';

export enum LevelsDefaultOpenCell {
  NO_LEVEL = 0,
  SKILLZ_LEVEL = 1,
  GAME_LEVEL = 2,
}

export const SKZ_LEAGUES_PAGE_SIZE = 50;

// WRONG GAME DEEP LINK CONSTANTS
export const WRONG_GAME_DEEP_LINK_FT_INVITE = 0;
export const WRONG_GAME_DEEP_LINK_FT_JOIN = 1;

// NUMBER CONSTANTS
export const MS_PER_SEC = 1000;
export const MS_PER_HALF_SEC = 500;
export const MS_PER_MIN = 60000;
export const SHORT_DELAY_MS = 300;
export const MINUTES_PER_DAY = 24 * 60;
export const SECONDS_PER_MIN = 60;
export const SECONDS_PER_DAY = 60 * 60 * 24;
export const MS_PER_DAY = SECONDS_PER_DAY * MS_PER_SEC;
export const USER_SUMMARY_ANIMATION_DURATION = MS_PER_HALF_SEC / 2;
export const IPHONEX_NOTCH_HEIGHT_PORTRAIT = 30;
export const TABLET_USABLE_AREA_WIDTH_PERCENT = '64%';
export const SKZ_MINIMUM_CASH_PLAY_AGE = 18;
export const SKZ_MINIMUM_FRIENDS_PLAY_AGE = 13;

export enum CurrencyTypes {
  CASH = 'CASH',
  TICKETZ = 'TICKETZ',
  Z = 'Z',
  MEDAL = 'MEDAL',
}

export enum UserInfoBarState {
  HIDDEN = 'userInfoHidden',
  BALANCE_HIDDEN = 'userInfoBalanceHidden',
  FULL_DISPLAY = 'userInfoFullDisplay',
}

export const MATCH_NOTIFICATIONS_LEVEL = 'notifications.batch.match.conclude';
export const CHAT_NOTIFICATIONS_LEVEL = 'notifications.batch.chat.message';

export enum NotificationLevels {
  NONE = 'NONE',
  AUTO = 'AUTOMATIC',
  ALL = 'INDIVIDUAL',
}

// FRAUD PROMPTS
export const FRAUD_NAVIGATOR = 'FraudPromptNavigator';
export const FRAUD_SUBMITTED = 'SUBMITTED';

// ACCOUNT MERGE
export const FTUE_ACCOUNT_TO_MERGE = 'FTUE_ACCOUNT_TO_MERGE';
export const FTUE_SHOULD_SHOW_ACCOUNT_MERGE = 'FTUE_SHOULD_SHOW_ACCOUNT_MERGE';

export const ACCEPT_TNC = 'ACCEPT_TNC';
/** When set, HomeScreen should show T&C on LegacyScreenPopped (e.g. back from LiveEventSearchScreen in AutoGuest path) */
export const SHOW_TNC_ON_HOME = 'SHOW_TNC_ON_HOME';
/*
Constant key to store FTUE credentials for Android user account and token.
Android does not return callbacks on SMS sign in and would require this to start the Account merge flow.
*/
export const FTUE_ACCOUNT_TO_MERGE_SMS_ANDROID = 'FTUE_ACCOUNT_TO_MERGE_SMS_ANDROID';
/* Constant to indicate whether a previous FTUE user completed the FTUE match tutorial before merging accounts */
export const FTUE_ACCOUNT_HAS_SEEN_FTUE_TUTORIAL = 'FTUE_ACCOUNT_HAS_SEEN_FTUE_TUTORIAL';

// WITHDRAWAL
export const PAYPAL = 'PayPal';
export const DEFAULT_PROCESSING_FEE = 1.5;
export const MINIMUM_WITHDRAWAL_WITHOUT_FEE = 10;
export const DEFAULT_INR_PROCESSING_FEE = 50;
export const MINIMUM_INR_WITHDRAWAL_WITHOUT_FEE = 500;
export const MAX_EMAIL_AMOUNT = 5;
export const AEROPAY_WITHDRAWAL = 'AEROPAY_WITHDRAWAL';
export const AEROPAY_RTP_WITHDRAWAL = 'AEROPAY_RTP_WITHDRAWAL';

// SKILLZ NEWS
export const DEFAULT_SKILLZ_NEWS_CHANNEL_NAME = 'Skillz News';
export const SKILLZ_NEWS_BANNER = 'SkillzNewsBanner';

// POOLED LIQUIDITY
export const INIT_STAKES_SELECTOR = 'InitializeStakesSelectorController';
export const STAKE_TOGGLED = 'StakeToggled';

// HOME STATUS TICKETZ NAVIGATION CONSTANTS
export const STORE = 'STORE';
export const TICKETZ_STORE = 'TICKETZ_STORE';

// TROPHIES
export const SKZ_TROPHIES_AWARDED = 'trophiesAwardedAmountSKZ';
export const SKZ_TROPHIES_CLAIMED = 'trophiesClaimedAmountSKZ';
export const SKZ_TROPHIES_TOTAL = 'trophiesTotalAmountSKZ';
export const SKZ_TROPHIES_FILTER_ALL = 'all';
export const SKZ_TROPHIES_FILTER_IN_PROGRESS = 'in_progress';
export const SKZ_TROPHIES_FILTER_COMPLETED = 'completed';
export const SKZ_TROPHIES_FILTER_ALL_V2 = 'all_v2';
export const SKZ_TROPHIES_DATA = 'trophiesDataSKZ';
export const SKZ_TROPHIES_REFRESH_EXPIRY_TIME = 'SKZ_TROPHIES_REFRESH_EXPIRY_TIME';

// STORE
export const SIMULATE_CASH_DISABLED_KEY = 'SKZ_SIMULATED_CASH_DISABLED_LOCATION_KEY';
export const SIMULATE_CASH_DISABLED_IP = 1;
export const SIMULATE_CASH_DISABLED_LOCATION = 2;
export const HAS_SEEN_CASH_DISABLED_LOCATION_WARNING = 'hasSeenCashDisabledLocationWarningSKZ';

// enum for differentiating the types of AccountActionView type
export enum AccountActionViewType {
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHANGE_USERNAME = 'USERNAME',
}

// Global Event Emitter
export const IS_HOME_SCREEN_FROM_PLAYER_LEVEL_UP_MODAL_OR_AD =
  'isHomeScreenFromPlayerLevelUpModalOrAd';
export const IS_HOME_SCREEN_FROM_AN_AD = 'isHomeScreenFromAnAd';

// Trophy
export const SHOW_NATIVE_TROPHIES = 'V1';
export const SHOW_JS_TROPHIES = 'V2';
export const ANIMATED_TROPHIES_ON_LOAD_COUNT = 2;
export const TROPHY_HOME_ANDROID_TABLET_WIDTH = 530;
export const TROPHY_HOME_IOS_TABLET_WIDTH = 530;

// Account Menu Badging Constants
export const SAVE_ACCOUNT_BUTTON = 'SaveAccountButton';
export const SAVE_ACCOUNT_BADGE_LAST_SEEN = 'saveAccountBadgeLastSeen';
export const PHONE_VERIFY_BUTTON = 'PhoneVerifyButton';
export const PHONE_VERIFY_BADGE_LAST_SEEN = 'phoneVerifyBadgeLastSeen';

// Match Select Constants
export const MATCH_SELECT_SCROLLED_TO_MATCH_CODE = 'matchSelectScrolledToMatchCode';
export const PLAY_TAB_LAST_SELECTED_CATEGORY = 'playTabLastSelectedCategory';
export const PLAY_TAB_LAST_SCROLL_OFFSET = 'playTabLastScrollOffset';
export const PLAY_TAB_IS_SHOWING_ALL_YOUR_TURN = 'playTabIsShowingAllYourTurn';
// In App Toasts
export const IN_APP_TOAST_EARNED_TROPHY_QUEUE = 'trophyEarnedModalQueueSKZ';

//Last Played Cash Tournament
export const LAST_PLAYED_CASH_TOURNAMENT = 'lastPlayedCashTournament';
//Last Played Live Event
export const LAST_PLAYED_LIVE_EVENT = 'lastPlayedLiveEvent';

// Deep Linking constants

export const DeepLinkTypes = {
  SHOW_LEADERBOARDS: 'showLeaderboards',
  SHOW_TROPHIES: 'showTrophies',
  SHOW_MATCH_RESULTS: 'tournamentResults',
};

// Live Events
export const EVENT_JOIN_CUT_OFF_PERIOD = 'joinCutoffTimePeriodSKZ';
export const EVENT_JOIN_WARN_PERIOD = 'joinWarningTimePeriodSKZ';

// IDFA
export const IDFAFTUEConfigs = {
  FIRST_OPEN: 'FIRST_OPEN',
  POST_FTUE: 'POST_FTUE',
  DO_NOT_SHOW: 'DO_NOT_SHOW',
};

// SKAdNetwork
export const AD_NETWORK_CONVERSION_FLAGS = 'adNetworkConversionFlags';
export const AdNetworkConversionTypes = {
  MATCH_ENTERED: 'MATCH_ENTERED',
  DEPOSITED: 'DEPOSITED',
  FTUE_COMPLETE: 'FTUE_COMPLETE',
  FIRST_CASH_MATCH: 'FIRST_CASH_MATCH',
};
export const APP_INSTALL_DATE = 'appInstallDateSKZ';
export const AD_NETWORK_MATCHES_ENTERED = 'totalMatchesEnteredSKZ';
export const AD_NETWORK_LAST_CONVERSION_VALUE = 'adNetworkLastConversionValueSKZ';

// Welcome back overlay
export const WB_OVERLAY_HEADER_HEIGHT = 60;
export const MODAL_OVERLAY_FOOTER_HEIGHT = 80;

//New League v3.0
//this will be removed when the server endpoint to indicate the user read concluded league is ready
export const LEAGUE_LAST_SEEN_CONCLUDED_LEAGUES_DATE = 'lastSeenConcludedLeaguesDateSKZ';

// LINKS
export const SKILLZ_WEBSITE_LINK = 'https://games.skillz.com';

// VENMO
export const CHECKOUT_VENMO_BANNER = 'checkout.venmo.banner';

// INSTAMATCH
export const INSTA_MATCH_FOUND = 'instaMatchFound';
export const INSTA_MATCH_HIDE = 'instaMatchHide';
export enum PlayerSegment {
  NONE = 'NONE',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  HIGHSTAKE = 'HIGHSTAKE',
}

// REWARD SYSTEMS
export const SKZ_REWARD_SYSTEMS_MODAL_LAST_SEEN = 'SKZRewardSystemsModalLastSeen';
export const SKZ_REWARD_SYSTEMS_NEXT_TIME_TO_ASSIGN = 'SKZRewardSystemsNextTimeToAssign';

// Daily Rewards V2
export const DAILY_CHALLENGES_TAB_FIRST_VIEW_OF_DAY = 'dailyChallengesTabFirstViewOfDaySKZ';

/**
 * The keys used for the trainer assets in the image set
 */
export enum ETrainerAssetKey {
  FaceLeft = 'FaceLeft',
  FaceRight = 'FaceRight',
}

export const TRAINER_ASSET_KEYS = {
  faceLeft: ETrainerAssetKey.FaceLeft,
  faceRight: ETrainerAssetKey.FaceRight,
};

//RECOMMENDED TEMPLATES CONDITIONS

export enum RecommendedTemplateConditions {
  NONE = 'NONE',
  LAST_PLAYED = 'LAST_PLAYED',
  MOST_PLAYED = 'MOST_PLAYED',
  UPSELL_LOW = 'UPSELL_LOW',
  UPSELL_MEDIUM = 'UPSELL_MEDIUM',
  UPSELL_HIGH = 'UPSELL_HIGH',
  LIVE_EVENT = 'LIVE_EVENT',
}

// Records the number of times the Bank promo in the checkout flow has been highlighted to the user.
export const CHECKOUT_DEFAULT_BANK_PROMO_TIMES = 'CHECKOUT_DEFAULT_BANK_PROMO_TIMES';
